export default process.env.NODE_ENV === 'production' ? 'https://amccrs-evr.verdedata.ro' : 'http://localhost:15555'
